import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon, Header, Grid, Divider, Popup, Flag } from 'semantic-ui-react';
import cn from 'classnames';
import { colors } from 'utils/colors';
import { ACCOUNTS_ANALYZE } from 'utils/features';
import {
  Accounts,
  Portfolio,
  Storage,
  ReallocateAccount,
  StockExposure,
  HoldingsConcentration,
  Dividends,
} from 'actions';
import { Segment, Feature, Loading, ButtonFilled } from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faSync,
  faMagnifyingGlassDollar,
  faHandHoldingDollar,
} from '@fortawesome/free-solid-svg-icons';

import { HoldingTable, GicTable, AssetChart } from './components';
import {
  getHoldTotalMarketValue,
  hasNegativeWeight,
} from '../../utils/helpers';
import { translation } from '../Translation/accounts';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tablePage: 1,
    };
  }

  componentWillMount() {
    const { dispatch, overview } = this.props;

    if (!overview) {
      return dispatch(Accounts.fetchAll());
    }

    return false;
  }

  componentWillUnmount() {
    const { dispatch, history } = this.props;

    if (
      history.location.pathname !== '/accounts/user' &&
      history.location.pathname !== '/portfolio/unsaved/overview'
    ) {
      dispatch(Accounts.saveSingleAccInfo(''));
    }
  }

  parseNum = (num) => {
    num = !num ? 0 : Math.round(num * 100) / 100;
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  analyze = (holdings) => {
    const { dispatch, history } = this.props;
    const gicHoldings = holdings.filter((holding) => holding.gic_ticker);
    Storage.removeItem('pwpa-has-exclude-holding');

    return dispatch(
      Accounts.analyze(
        holdings,
        history,
        { user_institution: 'Overview; All Accounts' },
        gicHoldings
      )
    );
  };

  increaseTablePage = () => {
    const { tablePage } = this.state;
    this.setState({ tablePage: tablePage + 1 });
  };

  decreaseTablePage = () => {
    const { tablePage } = this.state;
    this.setState({ tablePage: tablePage - 1 });
  };

  render() {
    const {
      dispatch,
      overview,
      history,
      accountList,
      pwpaExchangeRate,
      user_region,
      partnerName,
      french,
      language,
    } = this.props;
    const { tablePage } = this.state;
    const excludeGicHoldings =
      overview && overview.holdings.filter((holding) => !holding.gic_ticker);
    const gicHoldings =
      overview && overview.holdings.filter((holding) => holding.gic_ticker);
    const isWealthica = partnerName === 'wealthica';
    const hasNegativeWeights = hasNegativeWeight(overview.holdings);
    const isNegativePort =
      overview &&
      getHoldTotalMarketValue(overview, pwpaExchangeRate, user_region) < 0;

    return !overview ? (
      <Loading />
    ) : (
      <Segment>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Header
              size="large"
              content={french ? 'Vue d’ensemble' : 'Overview'}
              subheader={
                french ? 'Sommaire du compte' : 'Key account information'
              }
            />
            {hasNegativeWeights ? (
              isNegativePort ? (
                <p
                  style={{
                    color: `${colors.red}`,
                    fontWeight: 'bold',
                  }}
                >
                  <Icon name="warning sign" style={{}} />
                  {translation[language].WARNING_NEGATIVEPORT}
                </p>
              ) : (
                <p
                  style={{
                    color: `${colors.red}`,
                    fontWeight: 'bold',
                  }}
                >
                  <Icon name="warning sign" style={{}} />
                  {translation[language].WARNING_SHORTPOSITIONS}
                </p>
              )
            ) : null}
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'end',
              }}
            >
              <Feature name={ACCOUNTS_ANALYZE}>
                <CurrencyOption>
                  <ButtonFilled
                    className={cn('left', {
                      disabled: isNegativePort,
                    })}
                    icon="line chart"
                    color={colors.darkBlue}
                    onClick={() => {
                      dispatch(Storage.setItem('toggle_region', user_region));
                      this.analyze(overview.holdings);
                      dispatch(Portfolio.notSaveUrlSc());
                    }}
                    style={{ zIndex: 1 }}
                  >
                    {french ? 'Analyser' : 'Analyze'}
                  </ButtonFilled>

                  {overview.cash > 0 && (
                    <div
                      className="currency_item"
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        backgroundColor: 'white',
                      }}
                    >
                      <StyledButton
                        className="basic"
                        color={colors.darkBlue}
                        onClick={() => history.push('/accounts/overview/cash')}
                      >
                        <div className="flag cash">
                          <Icon
                            name="money"
                            style={{ fontSize: '1rem', margin: '0' }}
                          />
                        </div>
                        <div style={{ marginLeft: '36px' }}>
                          {french ? 'Argent liquide' : 'Incl. Cash'}
                        </div>
                      </StyledButton>
                    </div>
                  )}
                </CurrencyOption>
              </Feature>
            </div>
            {/* <Feature name={ACCOUNTS_ADDITIONAL_FEATURES}> */}
            <MoreActions>
              <IconPill
                color={colors.teal}
                onClick={() => {
                  dispatch(ReallocateAccount.resetReallocate());

                  history.push(`/tools/portfolio-reallocate`);
                }}
              >
                <FontAwesomeIcon icon={faSync} />
                <IconPillLabel>Reallocate</IconPillLabel>
              </IconPill>

              <IconPill
                color={colors.purple}
                onClick={() => {
                  dispatch(HoldingsConcentration.clear());
                  history.push(`/tools/holdings-concentration`);
                }}
              >
                <Icon name="chart pie" />
                <IconPillLabel>Stock Concentration</IconPillLabel>
              </IconPill>
              <IconPill
                color={colors.red}
                onClick={() => {
                  dispatch(StockExposure.clear());

                  history.push(`/tools/stock-exposure`);
                }}
              >
                <FontAwesomeIcon icon={faMagnifyingGlassDollar} />
                <IconPillLabel>Stock Exposure</IconPillLabel>
              </IconPill>
              <IconPill
                color={colors.darkGreen}
                onClick={() => {
                  dispatch(Dividends.clear());
                  history.push(`/tools/dividends`);
                }}
              >
                <FontAwesomeIcon icon={faHandHoldingDollar} />
                <IconPillLabel>
                  {french ? 'Dividendes' : 'Dividends'}
                </IconPillLabel>
              </IconPill>
            </MoreActions>
            {/* </Feature> */}
          </div>
        </div>

        <Divider fitted />

        {!overview.holdings.length ? (
          <Header
            size="small"
            content={
              french
                ? 'Lorsque vous ajoutez des titres à vos comptes, ils seront listés ici.'
                : 'When you add holdings to your accounts, they will be listed here.'
            }
          />
        ) : (
          <div>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column width={7}>
                  <div style={{ marginTop: '1.3rem' }}>
                    <div style={{ float: 'left', padding: '0 2rem 1rem 0' }}>
                      <Header
                        size="medium"
                        content={
                          french
                            ? 'Valeur totale des comptes'
                            : 'Total Accounts Value:'
                        }
                        sub
                        style={{ margin: 0, fontWeight: 700 }}
                      />
                      <Value className="main">
                        {`$${this.parseNum(overview.balance)}`}
                        <Flag
                          name="ca"
                          style={{
                            position: 'relative',
                            bottom: '7px',
                            marginLeft: 7,
                          }}
                        />
                      </Value>
                    </div>

                    <div style={{ float: 'left', padding: '0 0 1rem 0' }}>
                      <Header size="medium" sub style={{ margin: 0 }}>
                        {french ? 'Variation quotidienne' : 'Daily Change'}
                        <Popup
                          trigger={
                            <Icon
                              name="question circle outline"
                              style={{ fontSize: '1rem', verticalAlign: 'top' }}
                            />
                          }
                          position="right center"
                          content={
                            french
                              ? 'Des avoirs qui sont associés uniquement'
                              : 'Of holdings that are matched only'
                          }
                        />
                      </Header>
                      <Value>{`${overview.change}%`}</Value>
                    </div>
                  </div>

                  <div style={{ clear: 'both' }}>
                    <Header
                      size="medium"
                      content={
                        french
                          ? 'Valeur totale des avoirs'
                          : 'Total Holdings Value:'
                      }
                      sub
                      style={{ margin: 0 }}
                    />
                    <Value>{`$${this.parseNum(
                      overview.balance - overview.cash
                    )}`}</Value>
                  </div>
                  <div style={{ marginTop: '1.3rem' }}>
                    <Header
                      size="medium"
                      content={
                        french ? 'Valeur totale liquide' : 'Total Cash Value:'
                      }
                      sub
                      style={{ margin: 0 }}
                    />
                    <Value>{`$${this.parseNum(overview.cash)}`}</Value>
                  </div>
                </Grid.Column>
                <Grid.Column width={9}>
                  <Segment basic compact>
                    <Header
                      size="medium"
                      textAlign="center"
                      style={{ margin: '0 0 1rem 0' }}
                    >
                      {french
                        ? 'Répartition nette de l’actif'
                        : 'Net Asset Allocation'}
                      <Header.Subheader>
                        {french
                          ? 'Comprend les positions sous-jacentes des fonds équilibrés et des fonds de répartition d’actifs.'
                          : 'Includes a breakdown of the underlying holdings of balanced and asset allocation funds.'}
                        <Popup
                          trigger={
                            <Icon
                              name="question circle outline"
                              style={{
                                fontSize: '15px',
                                verticalAlign: 'initial',
                                color: 'dimgrey',
                              }}
                            />
                          }
                          position="top center"
                          content={
                            french
                              ? 'Analysez et utilisez le Scorecard pour approfondir les positions sous-jacentes afin de i) voir la répartition géographique par catégorie d’actif, et ii) vérifier la structure des fonds (p. ex., certains fonds utilisent des produits dérivés). Vous trouverez cette information dans Diversification → Catégorie d’actif (graphique du bas).'
                              : 'Analyze and use the Scorecard to drill down to the underlying holdings to i) see the geographical split by asset class, and ii) check fund structure (e.g., some funds use derivatives). You will find this information in Diversification → Asset Class (bottom chart).'
                          }
                          wide
                        />
                      </Header.Subheader>
                    </Header>
                    <AssetChart accounts={accountList} overview={overview} />
                  </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            {isWealthica && (
              <p
                style={{
                  fontWeight: 'bold',
                  position: 'absolute',
                  right: '7rem',
                  transform: 'translateY(2rem)',
                }}
              >
                {`${tablePage} of 2`}
              </p>
            )}

            <HoldingTable
              accountList={accountList}
              totalMarketValue={overview.balance - overview.cash}
              holdings={excludeGicHoldings.slice(0, 10)}
              accountName=""
              title={
                french ? 'Vos 10 plus grandes positions' : 'Top 10 Holdings'
              }
              isCombined
              increaseTablePage={this.increaseTablePage}
              decreaseTablePage={this.decreaseTablePage}
            />
            <GicTable
              user_region={user_region}
              gicHoldings={gicHoldings}
              totalMarketValue={overview.balance - overview.cash}
              title={french ? 'CPG' : 'GIC'}
              rate={pwpaExchangeRate}
            />
            {excludeGicHoldings.length !== 0 && (
              <P>
                {user_region === 'CA' ? (
                  // eslint-disable-next-line react/jsx-fragments
                  <React.Fragment>
                    {overview.currency === 'CAD'
                      ? french
                        ? 'Actuellement, nous disposons de données sur les actions/ETF canadiens et américains, les fonds communs de placement et les fonds séparés canadiens, ainsi que les fonds HISA en CAD/USD.'
                        : 'Currently, we have data for Canadian and US stocks/ETFs, Canadian mutual and segregated funds, and CAD/USD HISA funds.'
                      : french
                      ? 'Pour les comptes en dollars US, nous n’avons de données que pour les actions et FNB inscrits aux États-Unis, les fonds communs américains et les titres inscrits au Canada mais libellés en dollars US.'
                      : 'For USD accounts, we only have data for U.S.-listed stocks/ETFs, U.S. mutual funds, and Canadian-listed securities denominated in USD.'}
                    {user_region === 'CA' && overview.currency === 'CAD' && (
                      <Popup
                        trigger={
                          <Icon
                            name="question circle outline"
                            style={{
                              fontSize: '15px',
                              verticalAlign: 'initial',
                            }}
                          />
                        }
                        content={
                          french
                            ? 'Les fonds de CÉIÉ en CAD/USD sont inclus dans l’analyse en utilisant le rendement historique d’un fonds de CÉIÉ en CAD/USD représentatif détenu par une banque.'
                            : 'CAD/USD HISA funds are included in the analysis using the historical rates of a representative bank-owned CAD/USD HISA fund.'
                        }
                        position="top center"
                      />
                    )}
                    <br />
                    {french ? (
                      'Toute autre valeur mobilière sera exclue de l’analyse.'
                    ) : (
                      // eslint-disable-next-line react/jsx-fragments
                      <React.Fragment>
                        Any other securities such as{' '}
                        <b>private funds, individual bonds, and derivatives</b>{' '}
                        will be excluded from the analysis.
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ) : (
                  'Currently we only have data for U.S. listed stocks and ETFs, U.S. mutual funds, Bitcoin, and Ethereum. Any other security will be excluded from the analysis.'
                )}
              </P>
            )}
            {excludeGicHoldings.length !== 0 && (
              <P>
                {french
                  ? 'Le taux de change USD/CAD utilisé est de '
                  : 'USD/CAD exchange rate used is '}
                {pwpaExchangeRate || 1.3}
              </P>
            )}
          </div>
        )}
      </Segment>
    );
  }
}

Overview.propTypes = {
  history: PropTypes.object.isRequired,
  overview: PropTypes.object,
  dispatch: PropTypes.func,
  accountList: PropTypes.array,
  pwpaExchangeRate: PropTypes.number,
  user_region: PropTypes.string,
  partnerName: PropTypes.string,
  french: PropTypes.bool,
  language: PropTypes.string,
};

Overview.defaultProps = {
  overview: {},
  dispatch: () => {},
  accountList: [],
  pwpaExchangeRate: 0,
  user_region: 'CA',
  partnerName: '',
  french: false,
  language: 'en',
};

export default connect((state) => ({
  overview: state.Accounts.overview,
  accountList: state.Accounts.accountList,
  pwpaExchangeRate: state.Storage['pwpa-exchange-rate'],
  user_region: state.Storage.user_region || 'CA',
  partnerName: state.Storage['partner-name'],
  french: state.Storage.language === 'fr',
  language: state.Storage.language,
}))(Overview);

const Value = styled.div`
  font-size: 1.8rem;
  padding: 7px 0;
  &.main {
    font-size: 2.4rem;
    font-weight: 700;
    color: ${colors.orange};
  }
`;

const P = styled.p`
  color: rgba(0, 0, 0, 0.5);
  font-style: italic;
  margin: 0.7rem auto;
  max-width: 100%;
  line-height: 1.1rem;
  text-align: center;
`;

const CurrencyOption = styled.div`
  position: relative;
  display: inline-block;
  padding-right: 1rem;

  .currency_item {
    position: absolute;
    top: 100%;
    left: 0;
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease;
    z-index: 2;
    cursor: pointer;
  }

  &:hover .currency_item {
    opacity: 1;
    visibility: visible;
  }
`;

const StyledButton = styled.div`
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  font-size: 0.9rem;
  display: inline-block;
  min-height: 1em;
  min-width: 129px;
  height: 36px;
  border: none;
  text-align: center;
  outline: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  color: white;
  background-color: ${colors.darkBlue};
  vertical-align: top;
  line-height: 36px !important;
  user-select: none !important;
  margin-top: 5px !important;
  &:hover {
    box-shadow: inset 0 0 0 1.5px ${colors.darkBlue} !important;
    opacity: 0.8;
  }
  .flag {
    height: 100%;
    position: absolute;
    color: white;
    top: 0;
    width: 36px;
    background-color: ${colors.darkBlue};
    padding-right: 36px;
    &:before {
      position: absolute;
      line-height: 1;
      font-size: 1em;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .cash {
    padding-right: 0px;
  }
`;

const MoreActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: end;
  margin: 1rem 0;
`;

const IconPillLabel = styled.span`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  padding-right: 0;
  color: ${colors.darkGrey};
`;

const IconPill = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 14px 5px 8px;
  background: white;
  border: 1px solid #dededf;
  min-width: 36px;
  min-height: 36px;
  border-radius: 30px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ color, disabled }) =>
    disabled ? '#bfc3cb' : color || colors.textSecondary};
  white-space: nowrap;
  box-shadow: ${({ disabled }) =>
    disabled ? 'none' : '2px 2px 4px rgba(0, 0, 0, 0.25)'};
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};
  overflow: hidden;

  &:hover {
    border-color: ${({ color, disabled }) =>
      disabled ? colors.border : color || colors.border};
    opacity: ${({ disabled }) => (disabled ? 0.55 : 0.75)};

    ${IconPillLabel} {
      color: #333333;
    }
  }

  img,
  svg {
    width: 16px;
    height: 16px;
    object-fit: contain;
    flex-shrink: 0;
  }

  i.icon {
    margin: 0 !important;
    line-height: 1;
  }
`;
